// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3iJ8B","tab":"Tabs_tab__I2RZo","tabActive":"Tabs_tabActive__3cvwq"};